import { render, staticRenderFns } from "./DataPribadiDosen.vue?vue&type=template&id=8f775562"
import script from "./DataPribadiDosen.vue?vue&type=script&lang=js"
export * from "./DataPribadiDosen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports